/** Glifos Unicode Musical Symbols (Noto Music). */

export function musicNoteGlyph(durationBeats: number, isRest = false): string {
  if (isRest) {
    if (durationBeats >= 3.5) return "\u{1D13B}"; // whole rest
    if (durationBeats >= 1.5) return "\u{1D13C}"; // half rest
    if (durationBeats >= 0.75) return "\u{1D13D}"; // quarter rest
    return "\u{1D13E}"; // eighth rest
  }
  if (durationBeats >= 3.5) return "\u{1D15D}"; // whole note
  if (durationBeats >= 1.5) return "\u{1D15E}"; // half note
  if (durationBeats >= 0.75) return "\u{1D15F}"; // quarter note
  return "\u{1D160}"; // eighth note
}

/** Ancho mínimo por beat en la timeline (px). Blanca=2×, redonda=4×. */
export const TIMELINE_PX_PER_BEAT = 64;
